"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _components = require("@theme-ui/components");

var _withValidation = _interopRequireDefault(require("../../lib/withValidation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_components.Textarea.displayName = 'Textarea';
_components.Textarea.defaultProps = {
  rows: 4
};

var _default = (0, _withValidation["default"])(_components.Textarea);

exports["default"] = _default;